import { useOnClickOutside } from "hooks/ClickOutside";
import { useAppDispatch } from "hooks/hooks";
import { debounce } from "lodash";
import { useState, useRef } from "react";
import "../../../styles/Tooltip.scss";
import AddIcon from "@mui/icons-material/Add";
import { HistoricValueRow } from "./HistoricValueRow";
import { resourcesServices } from "Dashboard/scenes/Resources/services/resource.service";
import { updateHistoricValues } from "../details.slice";

interface IProps {
  active: boolean;
  setActive: Function;
  resourceId: number;
  historicValues: Object;
}

const EstimatedValueTooltip = ({
  active,
  setActive,
  historicValues,
  resourceId
}: IProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();

  const [year, setYear] = useState<string>();
  const [historicValue, setHistoricValue] = useState<string>();

  //   const { selectedIndex } = useSelector(selectState);

  // const delayedProjectUpdate = useMemo(
  //   () =>
  //     debounce(async (index: number, data: IUpdateProjectNoteRequestParams) => {
  //       try {
  //         const project = await projectService.updateProjectNote(data);
  //         //   dispatch(updateProject({ index, project }));
  //       } catch (err) {
  //         console.log(err);
  //       }
  //     }, 1000),
  //   [dispatch]
  // );

  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    // delayedProjectUpdate(selectedIndex, {
    //     projectId: project.projectId,
    //     note: event.target.value,
    // });
  };

  const resetHistoricValueInputs = () => {
    setYear("");
    setHistoricValue("");
  };

  const addHistoricValue = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (year && historicValue) {
      try {
        const newHistoricValue = await resourcesServices.addOrEditHistoricValueToResource({
          resourceId,
          year: Number(year),
          value: Number(historicValue)
        });
        dispatch(updateHistoricValues(newHistoricValue));
      } catch (err) {
        console.log(err);
      }
      resetHistoricValueInputs();
    }
  };

  const hideTip = () => {
    setActive(false);
  };
  useOnClickOutside(ref, hideTip);

  if (!active) return null;

  return (
    <div id="details-container" className="active" ref={ref}>
      <span className="details-title">Procenjena vrednost</span>
      <div id="details-top">
        <div className="details-header">
          <span>godina</span>
          <span>vrednost</span>
        </div>
        <div className="details-content">
          {historicValues &&
            Object.entries(historicValues).map(([key, value]) => {
              return (
                <HistoricValueRow
                  resourceId={resourceId}
                  year={key}
                  value={value}
                  key={key}
                />
              )
            })}
          <article className="details-article">
            <input
              className="details-cell"
              type="number"
              value={year || ""}
              onChange={(e) => {
                setYear(e.target.value);
              }}
            ></input>
            <input
              className="details-cell"
              type="number"
              value={historicValue || ""}
              onChange={(e) => {
                setHistoricValue(e.target.value);
              }}
            ></input>
            <button
              className="historic-value-button add-icon"
              onClick={addHistoricValue}
            >
              <AddIcon fontSize="small" />
            </button>
          </article>
        </div>
      </div>
    </div>
  );
};

export default EstimatedValueTooltip;
